import { Map, View } from "ol";
import { projection, extent, initialCenter, initialZoom } from "./config";
import { backgroundMapLayer, markerLayer } from "./layers";
import { defaults as defaultControls } from "ol/control";
import { defaults as defaultInteractions, DoubleClickZoom } from "ol/interaction";
import { createSvgElementWithUse } from "./utils";

// Get control container
const controlContainer = document.getElementById("control-container");
controlContainer.classList.add("vertical");

// Create icons for controls
const svgElementZoomIn = createSvgElementWithUse("./icons.svg#add_24px");
const svgElementZoomOut = createSvgElementWithUse("./icons.svg#remove_24px");

// Initialize the map with the specified target, layers, view, and other properties
export function initMap() {
  return new Map({
    target: "map",
    layers: [backgroundMapLayer, markerLayer],
    view: new View({
      center: initialCenter,
      zoom: initialZoom,
      projection: projection,
      extent: extent,
    }),
    controls: defaultControls({
      zoomOptions: {
        target: controlContainer,
        zoomInTipLabel: "Zooma in i kartan",
        zoomOutTipLabel: "Zooma ut i kartan",
        zoomInLabel: svgElementZoomIn,
        zoomOutLabel: svgElementZoomOut,
      },
    }),
    interactions: defaultInteractions({
      doubleClickZoom: false,
    }).extend([new DoubleClickZoom()]),
  });
}